import { useQuery } from '@tanstack/react-query';
import { searchApi } from '../api/searchApi';

export const useSearch = (searchTerm: string, codeType: string = '', category: string = '') => {
    return useQuery({
        queryKey: ['search', searchTerm, codeType, category],
        queryFn: () =>
            searchApi.searchCodes({
                searchTerm: searchTerm,
                codeType,
                category,
                pageNumber: 1,
                pageSize: 20,
                activeOnly: true,
            }),
        enabled: searchTerm.length > 0 || category.length > 0 || codeType.length > 0,
    });
};